/**
 * 购物车接口封装
 */
import request from '@/axios/request.js'

// queryBanners
export function queryBanners (data) {
    return request({
        url: '/api/home/banner',
        method: 'get',
        params: data,
    })
}
// queryMessage
export function queryMessage (data) {
    return request({
        url: '/api/home/message',
        method: 'get',
        params: data,
    })
}
// queryBanners
export function getOrderStatistics (data) {
    return request({
        url: '/api/order/statistics',
        method: 'get',
        params: data,
    })
}

// checkShowKefu
export function checkShowKefu(data) {
    return request({
        url: '/api/showKefu',
        method: 'get',
        params: data,
    })
}
export function closeKefu() {
    return request({
        url: '/api/closeKefu',
        method: 'post'
    })
}

// queryBanners
export function queryCartList (data) {
    return request({
        url: '/api/home/cart-list',
        method: 'get',
        params: data,
    })
}
// 根据系列查询各级类目树
export function queryCategoryList (data) {
    return request({
        //url: '/api/home/category-list',
        url: '/api/home/category-listV2',
        method: 'get',
        params: data,
    })
}

export function getHotDetails () {
    return request({
        url: '/api/product/hotSku',
        method: 'get',
    })
}

// 类目 
// export function queryHomeProduct (data) {
//     return request({
//         url: '/api/home-product',
//         method: 'get',
//         params: data,
//     })
// }

//类目属性过滤 只有类目
export function queryHomeProduct (data) {
    return request({
        url: '/api/home-productV2',
        method: 'get',
        params: data,
    })
}

//类目属性过滤 带属性参数
export function queryHomeProductPost (data) {
    return request({
        url: '/api/home-productPost',
        method: 'post',
        data,
    })
}

// queryBanners
export function queryAttrList (data) {
    return request({
        url: '/api/selection-product',
        method: 'get',
        params: data,
    })
}
// querySkuLists
export function querySkuLists (data) {
    if(data.userName){
        return request({
            url: '/api/getSkuList',
            method: 'post',
            data,
        })
    }else{
        return request({
            url: '/api/getSkuListVisit',
            method: 'post',
            data,
        }) 
    }
}

// 批量查询物料
export function querySkuListBatch (data) {
    return request({
        url: '/api/getSkuListBatch',
        method: 'post',
        data,
    })
}


export function getSkuDetails (params) {
    return request({
        url: '/api/product/getSkuDetails',
        method: 'get',
        params,
    })
}
export function getSkuDetailsVisit (params) {
    return request({
        url: '/api/product/getSkuDetailsVisit',
        method: 'get',
        params,
    })
}
// 批量添加购物车
export function addCart (data) {
    return request({
        url: '/api/cart/add',
        method: 'post',
        data,
    })
}
// 批量添加购物车
export function addCartBatch (data) {
    return request({
        url: '/api/cart/addBatch',
        method: 'post',
        data,
    })
}
// 批量添加购物车
export function queryProducts (data) {
    return request({
        url: '/api/query-product',
        method: 'get',
        params: data,
    })
}


// 查询系列的类目层级
export function getQueryCateByProductId (data) {
    return request({
        url: '/api/query-cate/products',
        method: 'get',
        params: data,
    })
}

// 查询首页楼层商品
export function floorProduct (data) {
    return request({
        url: '/api/home/floorProduct',
        method: 'post',
        data,
    })
}
